<div>
  <!-- Header -->
  <app-page-header title="Útmutató videók">
    Rövid, pár perces videókban összefoglaljuk számodra a <span translate="no">Mr. Kresz</span> alkalmazást és a viszonteladói rendszer működését
  </app-page-header>

  <!-- Video Categories -->
  <div>
    <!-- Iterate through categories -->
    @for (category of tutorialCategories; track category.name; let first = $first) {
    <div class="">
      <div class="py-2" [class.mt-6]="!first">
        <h2 class="text-xl font-semibold flex items-center">
          <ng-icon [name]="category.icon" class="w-6 h-6 mr-2"></ng-icon>
          {{category.name}}
        </h2>
      </div>
      <div>
        <div class="grid grid-cols-1 lg:grid-cols-2 gap-5">
          <!-- Video items -->
          @for (video of category.videos; track video.videoUrl) {
          <div >
            <app-youtube-player class="aspect-video rounded-lg overflow-hidden" [videoId]="video.videoUrl" [startSeconds]="0"
              [autoplay]="false">
            </app-youtube-player>
          </div>
          }
        </div>
      </div>
    </div>
    }
  </div>
</div>
